import { createRouter, createWebHistory } from "vue-router";
import Domains from "./views/Domains.vue";
import { NtaNotFound } from "@lr-notitia/notitia-ui/components";
import Messe from "./modules/messe/views/Messe.vue";
import IPad from "./modules/iPad/views/LandingPage.vue";
import BerufsberatungLandingPage from "./modules/berufsberatung/views/LandingPage.vue";
import ITNotrufLandingPage from "./modules/itNotruf/views/LandingPage.vue";
import HenkelLandingPage from "./modules/henkel/views/LandingPage.vue";
import escLandingPage from "./modules/esc/views/LandingPage.vue";
import Krankentransport from "./modules/krankentransport/views/Krankentransport.vue";
import Boehringer from "./modules/boehringer/views/LandingPage.vue";
import Ansbach from "./modules/ansbach/views/LandingPage.vue";

import dataspacesRoutes from "./modules/dataspaces/router";
import workspacesRoutes from "./modules/workspaces/router";
import betaRoutes from "./modules/beta/router";

const routes = [
	{
		path: "/:pathMatch(.*)*",
		name: "NotFound",
		component: NtaNotFound,
	},
	{
		path: "/",
		name: "Domains",
		component: Domains,
	},
	{
		path: "/berufsberatung",
		name: "Berufsberatung",
		component: BerufsberatungLandingPage,
		meta: { requiresAuth: false },
	},
	{
		path: "/itnotruf",
		name: "ITNotruf",
		component: ITNotrufLandingPage,
		meta: { requiresAuth: false },
	},
	{
		path: "/henkel",
		name: "Henkel",
		component: HenkelLandingPage,
		meta: { requiresAuth: false },
	},
	{
		path: "/esc",
		name: "evolving systems consulting",
		component: escLandingPage,
		meta: { requiresAuth: false },
	},
	{
		path: "/:domainId",
		redirect: (to: any) => `/${to.params.domainId}/template/dataspaces`,
	},
	{
		path: "/messe",
		name: "Messe",
		component: Messe,
	},
	{
		path: "/iPad",
		name: "iPad",
		component: IPad,
	},
	{
		path: "/krankentransport",
		name: "Krankentransport Landing Page",
		component: Krankentransport,
	},
	{
		path: "/krankentransport-fr",
		name: "Krankentransport Freiburg/Hochschwarzwald",
		component: Krankentransport,
	},
	{
		path: "/krankentransport-sb",
		name: "Krankentransport Saarland",
		component: Krankentransport,
	},
	{
		path: "/boehringer",
		name: "Boehringer",
		component: Boehringer,
	},
	{
		path: "/ils-ansbach",
		name: "Ansbach",
		component: Ansbach,
	},
	...dataspacesRoutes,
	...workspacesRoutes,
	...betaRoutes,
];

export default createRouter({
	history: createWebHistory(),
	routes,
});
